// extracted by css-extract-rspack-plugin
export default {"cls1":"useImageAttachment-cls1_xfU","cls2":"useImageAttachment-cls2_I2j useImageAttachment-cls1_xfU"};